import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["accept", "encoding", "onError", "parserOptions", "onFileLoaded", "onChange", "strict"];
import { forwardRef } from 'react';
import { parse } from 'papaparse';
import { jsx as _jsx } from "react/jsx-runtime";
var CSVReader = /*#__PURE__*/forwardRef((props, ref) => {
  var {
      accept = '.csv, text/csv',
      encoding = 'UTF-8',
      onError = () => {},
      parserOptions = {},
      onFileLoaded,
      onChange,
      strict = false
    } = props,
    reset = _objectWithoutPropertiesLoose(props, _excluded);
  var handleChangeFile = event => {
    onChange && onChange(event);
    var reader = new FileReader();
    var files = event.target.files;
    if (files.length > 0) {
      var _fileInfo = {
        name: files[0].name,
        size: files[0].size,
        type: files[0].type,
        modifiedAt: files[0].lastModified
      };
      if (strict && accept.indexOf(_fileInfo.type) <= 0) {
        onError(new Error("[strict mode] Accept type not respected: got '" + _fileInfo.type + "' but not in '" + accept + "'"));
        return;
      }
      reader.onload = _event => {
        var _csvData$data;
        var csvData = parse(reader.result, _extends({}, parserOptions, {
          error: onError,
          encoding: encoding
        }));
        onFileLoaded && onFileLoaded((_csvData$data = csvData == null ? void 0 : csvData.data) != null ? _csvData$data : [], _fileInfo, files[0], reader.result);
      };
      reader.readAsText(files[0], encoding);
    }
  };
  return /*#__PURE__*/_jsx("input", _extends({
    type: "file",
    name: "w-csv-reader-input"
  }, reset, {
    onChange: handleChangeFile,
    accept: accept,
    ref: ref
  }));
});
export default CSVReader;